enum EventDisplayType {
	Assaig = 0,
	Actuació = 1,
	Activitat = 2,
	Concurs = 3,
	Intercasteller2025 = 4,
	CabroRock = 5,
	Pilar = 6,
	Intercasteller2026 = 7,
}

export interface Event {
	name: string;
	start: string | null;
	end: string | null;
	location: string;
	cercavila?: any;
}

interface Day {
	displayType: EventDisplayType;
	displayName?: string;
	events: Event[];
	multiple?: boolean;
}
const bar = {
	name: 'Bar-Café l\'Aleta',
	start: 'Tot el dia',
	end: null,
	location: 'Parc Can Mulà',
}

export default class Months {
	static readonly Dimarts: Day = {
		displayType: EventDisplayType.Assaig,
		displayName: 'Assaig',
		events: [
			{
				name: 'Assaig General',
				start: '20:00',
				end: '22:00',
				location: 'C.C. l\'Era',
			},
		]
	}
	static readonly Divendres2024: Day = {
		displayType: EventDisplayType.Assaig,
		displayName: 'Assaig',
		events: [
			{
				name: 'Assaig de Gralles i Tabals',
				start: '19:00',
				end: '20:00',
				location: 'C.C. l\'Era',
			},
			{
				name: 'Assaig de Canalla',
				start: '20:00',
				end: '21:00',
				location: 'C.C. l\'Era',
			},
			{
				name: 'Assaig General',
				start: '21:00',
				end: '23:00',
				location: 'C.C. l\'Era',
			},
		]
	}
	static readonly Divendres2025: Day = {
		displayType: EventDisplayType.Assaig,
		displayName: 'Assaig',
		events: [
			{
				name: 'Assaig Canalla',
				start: '20:00',
				end: '21:00',
				location: 'C.C. l\'Era',
			},
			{
				name: 'Assaig Torres i Pilars',
				start: '20:00',
				end: '21:00',
				location: 'C.C. l\'Era',
			},
			{
				name: 'Assaig General',
				start: '21:00',
				end: '23:00',
				location: 'C.C. l\'Era',
			},
		]
	}
	static readonly DivendresReduit: Day = {
		displayType: EventDisplayType.Assaig,
		displayName: 'Assaig',
		events: [
			{
				name: 'Assaig de Gralles i Tabals',
				start: '19:00',
				end: '21:00',
				location: 'C.C. l\'Era',
			},
			{
				name: 'Assaig General',
				start: '21:00',
				end: '23:00',
				location: 'C.C. l\'Era',
			},
		]
	}

	static readonly Intercasteller2025: Day = {
		displayType: EventDisplayType.Intercasteller2025,
		displayName: 'Intercasteller',
		events: [
			{
				name: 'Intercasteller de Futbol',
				start: null,
				end: null,
				location: 'Lleida',
			}
		],
		multiple: true,
	}

	static readonly Intercasteller2026: Day = {
		displayType: EventDisplayType.Intercasteller2026,
		displayName: 'Intercasteller',
		events: [
			{
				name: 'Intercasteller de Futbol',
				start: null,
				end: null,
				location: 'Reus',
			}
		],
		multiple: true,
	}

	static readonly monthsData: {
		[key: string]: {
			[key: string]: Day;
		};
	} = {
			$1126: {
				1: {
					displayType: EventDisplayType.Actuació,
					displayName: 'XXXIII Diada',
					events: [
						{
							name: 'XXXIII Diada',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				}
			},
			$1026: {
				18: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Palautordera',
					events: [
						{
							name: 'Diada del Baix Montseny',
							start: '12:00',
							end: null,
							location: 'Plaça de la Vila, St. Maria Palautordera',
						}
					]
				},
				31: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Vigilia 33ª Diada',
					events: [
						{
							name: 'Vigilia XXXIII Diada',
							start: '19:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				}
			},
			$0926: {
				6: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Poblenou',
					events: [
						{

							name: 'Festa Major de Poblenou',
							start: '11:30',
							end: null,
							location: 'Plaça del Casino, Barcelona',
						}
					]
				},
				11: {
					displayType: EventDisplayType.Pilar,
					displayName: 'Diada Nacional',
					events: [
						{
							name: 'Pilar Diada Nacional de Catalunya',
							start: '12:00',
							end: null,
							location: 'Monument R. Casanova',
						}
					]
				},
				20: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Fira d\'Artesans',
					events: [
						{
							name: 'Paradeta i Taller de Fira d\'Artesans',
							start: '17:00',

							end: null,
							location: 'Carrer Portugal o Can Pacià',
						}
					]
				}
			},
			$0826: {
				15: {
					displayType: EventDisplayType.Pilar,
					displayName: 'Pilar Pregó',
					events: [
						{
							name: 'Diada de Festa Major',
							start: '19:30',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				16: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Festa Major',
					events: [
						{
							name: 'Diada de Festa Major',
							start: '18:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
			},
			$0726: {
				12: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Barcelona',
					events: [
						{
							name: 'Diada de Festa Major',
							start: '18:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				26: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Gallecs + Paella',
					events: [
						{
							name: 'Diada de Festa Major de Gallecs',
							start: '12:00',
							end: null,
							location: 'Gallecs',
						}
					]
				}
			},
			$0626: {
				6: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Santpedor',
					events: [
						{
							name: 'Festa Major de Granollers',
							start: '11:30',
							end: null,
							location: 'Plaça de la Porxada, Granollers',
						}
					]
				},
				14: {
					displayType: EventDisplayType.Actuació,
					displayName: 'TCVO',
					events: [
						{
							name: 'Festa Major de Montcada i Reixac',
							start: '12:00',
							end: null,
							location: 'Plaça l\'Església, Montcada i Reixac',
						}
					]
				},
				23: {
					displayType: EventDisplayType.Pilar,
					displayName: 'Flama del Canigó',
					events: [
						{
							name: 'Pilar Flama del Canigó',
							start: '20:00',
							end: null,
							location: 'Plaça Catalunya',
						}
					]
				}
			},
			$0526: {
				9: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Tarrega',
					events: [
						{
							name: 'Festa Major de Tarrega',
							start: '11:30',
							end: null,
							location: 'Can Muntanyola, L\'Ametlla del Vallès',
						}
					]
				},
				17: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Barcelona',
					events: [
						{
							name: 'Festa Major de Barcelona',
							start: '17:00',
							end: null,
							location: 'Plaça Major, Porqueres',
						}
					]
				},
				24: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Montcada',
					events: [
						{
							name: 'Diada de Tardor',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				}
			},
			$0426: {
				26: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Diada de Sant Jordi',
					events: [
						{
							name: 'Diada de Sant Jordi',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				}
			},
			$0326: {
				1: this.Intercasteller2026,
			},
			$0226: {
				28: this.Intercasteller2026,
			},
			$0126: {
				17: {
					displayType: EventDisplayType.Actuació,
					displayName: 'Sant Vicenç',
					events: [
						{
							name: 'Cercavila de Festa Major de Sant Vicenç',
							start: '11:30',
							end: null,
							location: 'INS Aiguaviva (Rambla Balmes)',
						},
						{
							name: 'Espectacle de Foc de Sant Vicenç',
							start: '20:45',
							end: null,
							location: 'Pl. Prat de la Riba',
						}
					]
				}
			},
			$1225: {},
			$1125: {
				'1': {
					displayType: EventDisplayType.CabroRock,
					displayName: 'Cabró Rock!',
					events: [
						{
							name: 'Cabró Rock',
							start: 'Tot el vespre',
							end: null,
							location: 'Can Guitet, Montmeló',
						}
					]
				},
				'2': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Diada de Manyacs',
					events: [
						{
							name: 'Diada de Tardor',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'4': this.Dimarts,
				'7': this.Divendres2025,
				'9': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Diada de Xics',
					events: [
						{
							name: 'Diada de Tardor',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'14': this.Divendres2025,
				'21': this.Divendres2025,
				'22': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Colònies',
					events: [
						{
							name: 'Colònies',
							start: 'Tot el dia',
							end: null,
							location: 'C.C. l\'Era',
						}
					],
					multiple: true,
				},
				'23': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Colònies',
					events: [
						{
							name: 'Colònies',
							start: 'Tot el dia',
							end: null,
							location: 'C.C. l\'Era',
						}
					],
					multiple: true,
				},
				'28': this.Divendres2025,
			},
			$1025: {
				'3': this.Divendres2025,
				4: {
					displayType: EventDisplayType.Pilar,
					displayName: 'Salut Mental',
					events: [
						{
							name: 'Pilar per la Salut Mental',
							start: '12:00',
							end: null,
							location: 'Parc Can Mulà',
						}
					]
				},
				'7': this.Dimarts,
				'10': this.Divendres2025,
				'14': this.Dimarts,
				'17': this.Divendres2025,
				'19': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Diada Baix Montseny',
					events: [
						{
							name: 'Diada del Baix Montseny',
							start: '12:00',
							end: null,
							location: 'Plaça de la Vila, St. Maria Palautordera',
						}
					]
				},
				'21': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial 33ª Diada',
							start: '20:00',
							end: null,
							location: 'Mercat Vell',
						}
					]
				},
				'23': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial 33ª Diada',
							start: '20:00',
							end: null,
							location: 'Mercat Vell',
						}
					]
				},
				'24': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial 33ª Diada',
							start: '20:00',
							end: null,
							location: 'Mercat Vell',
						}
					]
				},
				'25': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Vigília 33ª Diada',
					events: [
						{
							name: 'Vigília XXXIII Diada',
							start: '19:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'26': {
					displayType: EventDisplayType.Actuació,
					displayName: '33ª Diada',
					events: [
						{
							name: 'XXXIII Diada',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'28': this.Dimarts,
				'31': this.Divendres2025,
			},
			$0925: {
				'2': this.Dimarts,
				'5': this.Divendres2025,
				'7': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Poblenou',
					events: [
						{
							name: 'Festa Major de Poblenou',
							start: '11:30',
							end: null,
							location: 'Plaça del Casino, Barcelona',
						}
					]
				},
				'9': this.Dimarts,
				'11': {
					displayType: EventDisplayType.Pilar,
					displayName: 'Diada Nacional',
					events: [
						{
							name: 'Pilar Diada Nacional de Catalunya',
							start: '12:00',
							end: null,
							location: 'Monument R. Casanova',
						}
					]
				},
				'12': this.Divendres2025,
				'16': this.Dimarts,
				'19': this.Divendres2025,
				'20': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Paradeta + Taller',
					events: [
						{
							name: 'Paradeta i Taller de Fira d\'Artesans',
							start: '17:00',
							end: null,
							location: 'Carrer Portugal o Can Pacià',
						}
					]
				},
				'21': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Fira d\'Artesans',
					events: [
						{
							name: 'Diada Fira d\'Artesans',
							start: '12:00',
							end: null,
							location: 'Plaça Artesania',
						}
					]
				},
				'23': this.Dimarts,
				'26': this.Divendres2025,
				'28': {
					displayType: EventDisplayType.Actuació,
					displayName: 'FM Barri del Pedró',
					events: [
						{
							name: 'Festa Major del Barri del Pedró',
							start: '12:00',
							end: null,
							location: 'Plaça Angel Guimerà, Cornellà',
						}
					]
				},
				'30': this.Dimarts,
			},
			$0825: {
				'5': this.Dimarts,
				'8': this.Divendres2025,
				'12': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial Festa Major',
							start: '20:00',
							end: null,
							location: 'Mercat Vell',
						}
					]
				},
				'13': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial Festa Major',
							start: '20:00',
							end: null,
							location: 'Mercat Vell',
						}
					]
				},
				'14': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial Festa Major',
							start: '20:00',
							end: null,
							location: 'Mercat Vell',
						}
					]
				},
				'16': {
					displayType: EventDisplayType.Pilar,
					displayName: 'Pilar Pregó',
					events: [
						{
							name: 'Diada de Festa Major',
							start: '19:30',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'17': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Festa Major',
					events: [
						{
							name: 'Diada de Festa Major',
							start: '18:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
			},
			$0725: {
				'1': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig amb Xics',
					events: [
						{
							name: 'Assaig Conjunt amb Xics de Granollers',
							start: '20:00',
							end: null,
							location: '',
						}
					]
				},
				'4': this.Divendres2025,
				'5': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Meeples Amunt!',
					events: [
						{
							name: 'Meeples Amunt!',
							start: 'Tot el dia',
							end: null,
							location: 'Plaça Bonet i Muixí, Barcelona',
						}
					]
				},
				'6': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Poble Sec',
					events: [
						{
							name: 'Diada de Bous de la Bisbal',
							start: '18:00',
							end: null,
							location: 'Carrer Dr. Robert, La Bisbal del Penedès',
						}
					]
				},
				'8': this.Dimarts,
				'11': this.Divendres2025,
				'12': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Diada Jove Hospitalet',
					events: [
						{
							name: 'Diada de la Jove de l\'Hospitalet',
							start: '18:00',
							end: null,
							location: 'Pendent Concretar, L\'Hospitalet de Llobregat',
						}
					]
				},
				'13': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Lectura RRI',
					events: [
						{
							name: 'Lectura RRI',
							start: '19:00',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'15': this.Dimarts,
				'18': this.Divendres2025,
				'19': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Concurs de Cuina',
					events: [
						{
							name: 'Concurs de Cuina',
							start: '19:00',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'20': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Gallecs + Paella',
					events: [
						{
							name: 'Diada de Festa Major de Gallecs',
							start: '12:00',
							end: null,
							location: 'Gallecs',
						}
					]
				},
				'26': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Torneig Pàdel',
					events: [
						{
							name: 'I Torneig de Pàdel',
							start: 'Tot el dia',
							end: null,
							location: 'Restaurant Can Prat, Mollet del Vallès',
						}
					]
				}
			},
			$0625: {
				'1': {
					displayType: EventDisplayType.Actuació,
					displayName: 'TCVO',
					events: [
						{
							name: 'Trobada de Colles del Vallès Oriental',
							start: '11:30',
							end: null,
							location: 'Plaça de la Porxada, Granollers',
						}
					]
				},
				'3': this.Dimarts,
				'6': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial "Porta un Amic"',
							start: '20:00',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'8': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Montcada',
					events: [
						{
							name: 'Festa Major de Montcada i Reixac',
							start: '12:00',
							end: null,
							location: 'Plaça l\'Església, Montcada i Reixac',
						}
					]
				},
				'10': this.Dimarts,
				'13': this.Divendres2025,
				'14': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Colònies Canalla',
					events: [
						{
							name: 'Colònies de Canalla',
							start: 'Tot el dia',
							end: null,
							location: '',
						}
					],
					multiple: true,
				},
				'15': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Colònies Canalla',
					events: [
						{
							name: 'Colònies de Canalla',
							start: 'Tot el dia',
							end: null,
							location: '',
						}
					],
					multiple: true,
				},
				'17': this.Dimarts,
				'20': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Manyacs',
					events: [
						{
							name: 'Assaig Conjunt amb Manyacs de Parets',
							start: '21:00',
							end: null,
							location: 'La Morada, Parets del Vallès',
						}
					]
				},
				'23': {
					displayType: EventDisplayType.Pilar,
					displayName: 'Flama del Canigó',
					events: [
						{
							name: 'Pilar Flama del Canigó',
							start: '20:00',
							end: null,
							location: 'Plaça Catalunya',
						}
					]
				},
				'25': this.Dimarts,
				'27': this.Divendres2025,
				'29': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Centelles',
					events: [
						{
							name: 'Diada de Centelles',
							start: '12:00',
							end: null,
							location: 'Plaça Mossen Joan Xadri, Centelles',
						}
					]
				},
			},
			$0525: {
				'2': this.Divendres2025,
				'6': this.Dimarts,
				'9': this.Divendres2025,
				'11': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Ametlla del Vallès',
					events: [
						{
							name: 'Fira de Sant Ponç',
							start: '11:30',
							end: null,
							location: 'Can Muntanyola, L\'Ametlla del Vallès',
						}
					]
				},
				'13': this.Dimarts,
				'16': this.Divendres2025,
				'17': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Porqueres',
					events: [
						{
							name: 'Festa Major de Porqueres',
							start: '17:00',
							end: null,
							location: 'Plaça Major, Porqueres',
						}
					]
				},
				'20': this.Dimarts,
				'23': this.Divendres2025,
				'24': {
					displayType: EventDisplayType.Pilar,
					displayName: 'FM Plana Lledó',
					events: [
						{
							name: 'Cercavila a la Festa del Barri de Plana Lledó',
							start: '10:00',
							end: null,
							location: '',
						}
					]
				},
				'25': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Taller BBQ Solidària',
					events: [
						{
							name: 'Taller BBQ Solidària',
							start: 'Tot el dia',
							end: null,
							location: 'Parc de Can Mulà',
						}
					]
				},
				'27': this.Dimarts,
				'30': this.Divendres2025,
				'31': {
					displayType: EventDisplayType.Pilar,
					displayName: 'Pilar Arlequí',
					events: [
						{
							name: 'Pilar Arlequí',
							start: '17:00',
							end: null,
							location: '',
						}
					]
				},
			},
			$0425: {
				'1': this.Dimarts,
				'4': this.Divendres2025,
				'5': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Barcelona',
					events: [
						{
							name: 'Diada de la Muixeranga de Barcelona',
							start: '12:00',
							end: null,
							location: 'Plaça Bonet i Muixí, Barcelona',
						}
					]
				},
				'8': this.Dimarts,
				'11': this.Divendres2025,
				'22': this.Dimarts,
				'23': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Paradeta Sant Jordi',
					events: [
						{
							name: 'Paradeta de Sant Jordi',
							start: 'Tot el dia',
							end: null,
							location: '',
						}
					]
				},
				'25': this.Divendres2025,
				'27': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Diada de Sant Jordi',
					events: [
						{
							name: 'Diada de Sant Jordi',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'29': this.Dimarts,
			},
			$0325: {
				'4': this.Dimarts,
				'7': this.Divendres2025,
				'9': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Calçots',
					events: [
						{
							name: 'Calçotada',
							start: 'TOT EL DIA',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'11': this.Dimarts,
				'14': this.Divendres2025,
				'18': this.Dimarts,
				'21': this.Divendres2025,
				'23': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Diada d\'Inici',
					events: [
						{
							name: 'Diada d\'Inici Temporada',
							start: '12:00',
							end: null,
							location: 'Pista Barri de Lourdes',
						}
					]
				},
				'25': this.Dimarts,
				'28': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Obert al Poble',
							start: '20:00',
							end: '23:00',
							location: 'Mercat Vell',
						},
					]
				},
			},
			$0225: {
				'7': this.Divendres2025,
				'8': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Assemblea General',
					events: [
						{
							name: 'Assemblea General Extraordinària',
							start: '19:30',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'14': this.Divendres2025,
				'21': this.Divendres2025,
				'22': this.Intercasteller2025,
				'23': this.Intercasteller2025,
				'28': this.Divendres2025,
			},
			$0125: {
				'11': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Assemblea General',
					events: [
						{
							name: 'Assemblea General Extraordinària',
							start: '20:00',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'17': Months.Divendres2025,
				'18': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Sant Vicenç',
					events: [
						{
							name: 'Cercavila de Festa Major de Sant Vicenç',
							start: '11:30',
							end: null,
							location: 'INS Aiguaviva (Rambla Balmes)',
						},
						{
							name: 'Espectacle de Foc de Sant Vicenç',
							start: '20:45',
							end: null,
							location: 'Pl. Prat de la Riba',
						}
					]
				},
				'24': Months.Divendres2025,
				'31': Months.Divendres2025,
			},
			$1224: {
				'15': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Assemblea General',
					events: [
						{
							name: 'Assemblea General Ordinària',
							start: '11:00',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				}
			},
			$1124: {
				'1': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig Conjunt amb Manyacs de Parets',
							start: '20:30',
							end: '22:30',
							location: 'La Morada',
						}
					]
				},
				'3': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de Manyacs de Parets',
							start: '11:30',
							end: null,
							location: 'Plaça de la Vila, Parets del Vallès',
						}
					]
				},
				'5': Months.Dimarts,
				'8': Months.Divendres2024,
				'9': {
					'displayType': EventDisplayType.Actuació,
					displayName: 'Granollers',
					'events': [
						{
							'name': 'Freestyle Show Granollers',
							'start': '20:00',
							'end': null,
							'location': 'Palau d\'Esports, Granollers',
						}
					]
				},
				'10': {
					displayType: EventDisplayType.Actuació,
					displayName: 'Granollers',
					events: [
						{
							name: 'Diada de Xics de Granollers',
							start: '11:30',
							end: null,
							location: 'Plaça de la Porxada, Granollers',
						}
					]
				},
				'15': Months.Divendres2024,
				'22': Months.Divendres2024,
				'23': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Colònies',
					events: [
						{
							name: 'Colònies',
							start: 'Tot el dia',
							end: null,
							location: null,
						}
					],
					multiple: true,
				},
				'24': {
					displayType: EventDisplayType.Activitat,
					displayName: 'Colònies',
					events: [
						{
							name: 'Colònies',
							start: 'Tot el dia',
							end: null,
							location: null,
						}
					],
					multiple: true,
				},
				'29': Months.Divendres2024,
			},
			$1024: {
				'1': Months.Dimarts,
				'2': Months.Dimarts,
				'4': Months.Divendres2024,
				'5': {
					displayType: EventDisplayType.Concurs,
					events: [
						{
							name: 'Concurs de Castells',
							start: 'Tot el dia',
							end: null,
							location: 'Tarraco Arena Plaça, Tarragona',
						}
					]
				},
				'8': Months.Dimarts,
				'11': Months.Divendres2024,
				'12': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Festa Major Sant Ildefons',
							start: '12:00',
							end: null,
							location: 'Cornellà',
						}
					]
				},
				'15': Months.Dimarts,
				'18': Months.Divendres2024,
				'20': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada Baix Montseny',
							start: '12:00',
							end: null,
							location: 'Plaça de la Vila, St. Maria Palautordera',
						}
					]
				},
				'22': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'Mercat Vell',
						},
						{
							name: 'Assaig General',
							start: '20:00',
							end: '22:00',
							location: 'Mercat Vell',
						},
					]
				},
				'24': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'Mercat Vell',
						},
						{
							name: 'Assaig General',
							start: '20:00',
							end: '22:00',
							location: 'Mercat Vell',
						},
					]
				},
				'25': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'Mercat Vell',
						},
						{
							name: 'Assaig General',
							start: '20:00',
							end: '23:00',
							location: 'Mercat Vell',
						},
					]
				},
				'26': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Vigília XXXII Diada',
							start: '19:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'27': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'XXXII Diada',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'29': Months.Dimarts,
			},
			$0924: {
				'3': Months.Dimarts,
				'6': Months.Divendres2024,
				'8': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada a Montserrat',
							start: '16:00',
							end: null,
							location: 'Museu de Montserrat',
						}
					]
				},
				'10': Months.Dimarts,
				'11': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Pilar Diada Nacional de Catalunya',
							start: '12:00',
							end: null,
							location: 'Monument R. Casanova',
						}
					]
				},
				'13': Months.Divendres2024,
				'14': {
					displayType: EventDisplayType.Activitat,
					events: [
						{
							name: 'Paradeta / Taller de Castells',
							start: 'Tot el dia',
							end: null,
							location: 'C/ Portugal o Can Pacià',
						}
					]
				},
				'15': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada Fira d\'Artesans',
							start: '12:00',
							end: null,
							location: 'Plaça Artesania',
						}
					]
				},
				'17': Months.Dimarts,
				'20': Months.Divendres2024,
				'24': Months.Dimarts,
				'25': Months.Dimarts,
				'27': Months.Divendres2024,
			},
			$0824: {
				'6': Months.Dimarts,
				'9': Months.Divendres2024,
				'13': Months.Dimarts,
				'15': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial Festa Major',
							start: '20:00',
							end: '22:00',
							location: 'Plaça Catalunya',
						}
					]
				},
				'17': {
					displayType: EventDisplayType.Actuació,
					events: [
						bar,
						{
							name: 'Pilar Pregó Festa Major',
							start: '19:30',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'18': {
					displayType: EventDisplayType.Actuació,
					events: [
						bar,
						{
							name: 'Pilar',
							start: '16:00',
							end: null,
							location: 'Residència La Immaculada',
						},
						{
							name: 'Diada de Festa Major',
							start: '18:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'19': {
					displayType: EventDisplayType.Activitat,
					events: [
						bar,
						{
							name: 'Vermut Musical',
							start: '12:00',
							end: null,
							location: 'Parc de Can Mulà',
						}
					]
				},
				'20': {
					displayType: EventDisplayType.Activitat,
					events: [
						bar,
					]
				},
			},
			$0724: {
				'2': Months.Dimarts,
				'5': Months.Divendres2024,
				'6': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de Bous de la Bisbal',
							start: '18:00',
							end: null,
							location: 'Carrer Dr. Robert, La Bisbal del Penedès',
						}
					]
				},
				'7': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada d\'Estiu',
							start: '11:30',
							end: null,
							location: 'Plaça del Rei, Barcelona',
						}
					]
				},
				'9': Months.Dimarts,
				'12': Months.Divendres2024,
				'13': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de la Llotgeta',
							start: '20:00',
							end: null,
							location: 'Plaça de l\'Om',
						}
					]
				},
				'16': Months.Dimarts,
				'18': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial Gallecs',
							start: '20:00',
							end: '22:00',
							location: 'C.C. l\'Era',
						}
					]
				},
				'19': Months.Divendres2024,
				'20': {
					displayType: EventDisplayType.Activitat,
					events: [
						{
							name: 'Concurs de Cuina',
							start: '19:00',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'21': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de Festa Major de Gallecs',
							start: '12:00',
							end: null,
							location: 'Gallecs',
						}
					]
				},
				'23': Months.Dimarts,
				'26': Months.Divendres2024,
			},
			$0624: {
				'1': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Festival Arlequí',
							start: '17:00',
							end: null,
							location: 'Ajuntament',
						}
					]
				},
				'4': Months.Dimarts,
				'5': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Roda de Premsa TCVO',
							start: '19:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'7': Months.Divendres2024,
				'8': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada Plaça de Nou',
							start: '18:00',
							end: null,
							location: 'Plaça de l\'Ajuntament, Hospitalet de Llobregat',
						}
					]
				},
				'9': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Meeples Amunt',
							start: '10:00',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'11': Months.Dimarts,
				'13': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig Especial TCVO',
							start: '20:00',
							end: '22:00',
							location: 'C.C. l\'Era',
						}
					]
				},
				'14': Months.Divendres2024,
				'16': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Trobada de Colles del Vallès Oriental',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'18': Months.Dimarts,
				'23': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Pilar Flama del Canigó',
							start: '20:00',
							end: null,
							location: 'Plaça Catalunya',
						}
					]
				},
				'25': Months.Dimarts,
				'28': Months.Divendres2024,
			},
			$0524: {
				'1': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada Festa Major Òdena',
							start: '11:00',
							end: null,
							location: 'Plaça Major, Òdena',
						}
					]
				},
				'3': Months.Divendres2024,
				'7': Months.Dimarts,
				'10': Months.Divendres2024,
				'11': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'III Trobada de Gralles',
							start: '19:00',
							end: null,
							location: 'Ripollet',
						}
					]
				},
				'12': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de l\'Ascensió',
							start: '11:30',
							end: null,
							location: 'Plaça de la Porxada, Granollers',
						}
					]
				},
				'14': Months.Dimarts,
				'17': Months.Divendres2024,
				'19': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada Festa Major Montcada',
							start: '12:00',
							end: null,
							location: 'Plaça de l\'Església, Montcada i Reixac',
						}
					]
				},
				'21': Months.Dimarts,
				'24': Months.Divendres2024,
				'25': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Festa Major de Plana Lledó',
							start: '10:00',
							end: null,
							location: 'Plaça Joan Miró',
						}
					]
				},
				'28': Months.Dimarts,
				'31': Months.Divendres2024,
			},
			$0324: {
				'1': Months.DivendresReduit,
				'2': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Assemblea de Pressupostos',
							start: '19:30',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'3': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Calçotada de la colla',
							start: '10:00',
							end: null,
							location: 'C.C. l\'Era',
						},
					]
				},
				'5': Months.Dimarts,
				'7': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Torres i Pilars',
							start: '20:00',
							end: '22:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'8': Months.DivendresReduit,
				'12': Months.Dimarts,
				'15': Months.Divendres2024,
				'17': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada d\'Inici',
							start: '12:00',
							end: null,
							location: 'Plaça Pou del Greix, Badalona',
						}
					]
				},
				'19': Months.Dimarts,
				'22': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'C.C. l\'Era',
						},
						{
							name: 'Taller de Castells',
							start: '19:00',
							end: '20:00',
							location: 'Mercat Vell',
						},
						{
							name: 'Assaig General',
							start: '20:00',
							end: '22:30',
							location: 'Mercat Vell',
						},
					]
				}
			},
			$0224: {
				'2': Months.DivendresReduit,
				'6': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'9': Months.DivendresReduit,
				'13': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'16': Months.DivendresReduit,
				'20': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'23': Months.DivendresReduit,
				'24': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Intercasteller de Futbol',
							start: null,
							end: null,
							location: 'Berga',
						}
					]
				},
				'25': {
					...{
						displayType: EventDisplayType.Actuació,
						events: [
							{
								name: 'Intercasteller de Futbol',
								start: null,
								end: null,
								location: 'Berga',
							}
						]
					},
					multiple: true,
				},
				'27': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'C.C. l\'Era',
						},
					]
				}
			},
			$1223: {
				'2': Months.DivendresReduit,
				'3': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Intercasteller de Bàsquet',
							start: null,
							end: null,
							location: 'Pavelló Xavier Tondo, Valls',
						}
					]
				},
				'5': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '21:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'8': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '21:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'12': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '21:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'15': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '21:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'17': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'AGO',
							start: '11:30',
							end: null,
							location: 'C.C. l\'Era',
						}
					]
				},
				'19': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '21:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'22': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '21:00',
							location: 'C.C. l\'Era',
						},
					]
				},
				'23': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Concert de Gralles i Tabals',
							start: '12:00',
							end: null,
							location: 'Jardinet, Mollet del Vallès',
						}
					]
				},
			},
			$1123: {
				'3': Months.DivendresReduit,
				'5': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Cercavila',
							start: '11:00',
							end: null,
							location: 'C/ Ponent 18, Parets del Vallès',
						},
						{
							name: 'Diada de Manyacs de Parets',
							start: '11:30',
							end: null,
							location: 'Plaça de la Vila, Parets del Vallès',
						}
					]
				},
				'7': Months.Dimarts,
				'10': Months.DivendresReduit,
				'12': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de Xics de Granollers',
							start: '11:30',
							end: null,
							location: 'Plaça de la Porxada, Granollers',
						}
					]
				},
				'17': Months.DivendresReduit,
				'18': {
					displayType: EventDisplayType.Actuació,
					multiple: true,
					events: [
						{
							name: 'Colònies de la Colla',
							start: null,
							end: null,
							location: null,
						}
					]
				},
				'19': {
					displayType: EventDisplayType.Actuació,
					multiple: true,
					events: [
						{
							name: 'Colònies de la Colla',
							start: null,
							end: null,
							location: null,
						}
					]
				},
				'24': Months.DivendresReduit,
			},
			$1023: {
				'3': Months.Dimarts,
				'6': Months.Divendres2024,
				'7': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Cercavila',
							start: '17:00',
							end: null,
							location: 'Rambla Nova',
						},
						{
							name: 'Acte de la Cultural',
							start: '18:45',
							end: null,
							location: 'Parc de Can Mulà',
						}
					]
				},
				'10': Months.Dimarts,
				'13': Months.Divendres2024,
				'14': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de Tardor',
							start: '17:30',
							end: null,
							location: 'Parc Neus Català, Castelldefels',
						}
					]
				},
				'15': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Cercavila',
							start: '11:00',
							end: null,
							location: 'Parc Pau Casals, Santa Maria de Palautordera',
						},
						{
							name: 'Bateig Castellers Baix Montseny',
							start: '12:00',
							end: null,
							location: 'Plaça de la Vila, Santa Maria de Palautordera',
						}
					]
				},
				'17': Months.Dimarts,
				'20': Months.Divendres2024,
				'24': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'Mercat Vell',
						},
						{
							name: 'Assaig Especial de Diada',
							start: '20:00',
							end: '22:00',
							location: 'Mercat Vell',
						},
					]
				},
				'26': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'Mercat Vell',
						},
						{
							name: 'Assaig Especial de Diada',
							start: '20:00',
							end: '22:00',
							location: 'Mercat Vell',
						},
					]
				},
				'27': {
					displayType: EventDisplayType.Assaig,
					displayName: 'Assaig Especial',
					events: [
						{
							name: 'Assaig de Gralles i Tabals',
							start: '19:00',
							end: '20:00',
							location: 'Mercat Vell',
						},
						{
							name: 'Assaig Especial de Diada',
							start: '20:00',
							end: '22:00',
							location: 'Mercat Vell',
						},
					]
				},
				'28': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Vigília XXXI Diada CdM',
							start: '19:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
				'29': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'XXXI Diada CdM',
							start: '12:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						}
					]
				},
			},
			$0923: {
				'5': Months.Dimarts,
				'8': Months.Divendres2024,
				'10': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada Nacional de Catalunya',
							start: '12:00',
							end: null,
							location: 'Caldes de Montbui, Plaça Font del Lleó',
						}
					]
				},
				'11': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Pilar Diada Nacional de Catalunya',
							start: '12:00',
							end: null,
							location: 'Mollet del Vallès, Monument R. Casanova',
						}
					]
				},
				'12': Months.Dimarts,
				'15': Months.Divendres2024,
				'16': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Taller Fira Artesans',
							start: '18:00',
							end: null,
							location: 'Mollet del Vallès, C/ Portugal o Can Pacià',
						},
						{
							name: 'Paradeta Fira Artesans',
							start: 'Tot el dia',
							end: null,
							location: 'Mollet del Vallès, C/ Portugal o Can Pacià',
						}
					]
				},
				'17': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Cercavila de la Fira d\'Artesans',
							start: '11:15',
							end: null,
							location: 'Mollet del Vallès, Plaça Catalunya',
						},
						{
							name: 'Diada Fira d\'Artesans',
							start: '12:00',
							end: null,
							location: 'Mollet del Vallès, Plaça Artesania',
						}
					]
				},
				'19': Months.Dimarts,
				'22': Months.Divendres2024,
				'26': Months.Dimarts,
				'29': Months.Divendres2024,
			},
			$0823: {
				'8': Months.Dimarts,
				'11': Months.Divendres2024,
				'16': Months.Dimarts,
				'17': {
					displayType: EventDisplayType.Assaig,
					events: [
						{
							name: 'Assaig General',
							start: '20:00',
							end: '22:00',
							location: 'Plaça Catalunya',
						}
					]
				},
				'19': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Cercavila Pregó Festa Major',
							start: '19:30',
							end: null,
							location: 'Plaça Pau Casals',
						},
						{
							name: 'Pilar Caminat',
							start: '19:30',
							end: null,
							location: 'Plaça Prat de la Riba',
						},
						{
							name: 'Pilar Pregó Festa Major',
							start: '20:00',
							end: null,
							location: 'Plaça Prat de la Riba',
						},
						{
							name: 'Bar-Café l\'Aleta',
							start: 'Tot el dia',
							end: null,
							location: 'Parc Can Mulà',
						}
					]
				},
				'20': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de Festa Major',
							start: 'cerc: 17:15',
							end: 'actu: 18:00',
							location: 'Plaça de Prat de la Riba',
						},
						{
							name: 'Bar-Café l\'Aleta',
							start: 'Tot el dia',
							end: null,
							location: 'Parc Can Mulà',
						}
					]
				},
				'21': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Bar-Café l\'Aleta',
							start: 'Tot el dia',
							end: null,
							location: 'Parc Can Mulà',
						},
						{
							name: 'Concert Vermut Gralles i Tabals',
							start: '12:00',
							end: null,
							location: 'Parc Can Mulà',
						}
					]
				},
				'22': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Bar-Café l\'Aleta',
							start: 'Tot el dia',
							end: null,
							location: 'Parc Can Mulà',
						}
					]
				},
			},
			$0723: {
				'1': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Cercavila Festa Barri Plana Lledó',
							start: '10:00',
							end: null,
							location: 'Mollet del Vallès, Plana Lledó',
						}
					]
				},
				'4': Months.Dimarts,
				'7': Months.Divendres2024,
				'8': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Colònies de Canalla',
							start: null,
							end: null,
							location: null,
						}
					],
					multiple: true,
				},
				'9': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Colònies de Canalla',
							start: null,
							end: null,
							location: null,
						}
					],
					multiple: true,
				},
				'11': Months.Dimarts,
				'14': Months.Divendres2024,
				'15': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de la Colla Jove de l\'Hospitalet',
							start: '18:30',
							end: null,
							location: 'Plaça Francesc Macià',
						}
					]
				},
				'18': Months.Dimarts,
				'21': Months.Divendres2024,
				'22': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Concurs de cuina',
							start: '19:00',
							end: null,
							location: 'C.C. La Era',
						}
					]
				},
				'23': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada de Festa Major de Gallecs',
							start: '12:00',
							end: null,
							location: 'Gallecs',
						},
						{
							name: 'Paellada',
							start: '15:00',
							end: null,
							location: 'C.C. La Era',
						}
					]
				},
				'25': Months.Dimarts,
				'28': Months.Divendres2024,
			},
			$0523: {
				'2': Months.Dimarts,
				'5': Months.Divendres2024,
				'7': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Diada Aniversari Bateig',
							start: '12:00',
							end: null,
							location: 'Castellar del Vallès, Plaça Fabrica Nova',
						}
					]
				},
				'9': Months.Dimarts,
				'12': Months.Divendres2024,
				'13': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Pilar Nit dels Museus',
							start: '22:30',
							end: '23:00',
							location: 'Museu Abelló, Mollet del Vallès',
						}
					]
				},
				'16': Months.Dimarts,
				'19': Months.Divendres2024,
				'20': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Cercavila',
							start: '10:00',
							end: null,
							location: 'Mollet del Vallès, Plana Lledó',
						},
						{
							name: 'Diada Festa Major Porqueres',
							start: '17:30',
							end: null,
							location: 'Porqueres, Plaça Major',
						}
					]
				},
				'23': Months.Dimarts,
				'26': Months.Divendres2024,
				'27': {
					displayType: EventDisplayType.Actuació,
					events: [
						{
							name: 'Torneig Futbol Sala Intercolles',
							start: '09:30',
							end: null,
							location: 'Mollet del Vallès, Escola Montseny',
						}
					]
				},
				'30': Months.Dimarts,
			}
		}

	static readonly yearVacations = {
		$25: [
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-01-01`), new Date(`${new Date().getFullYear()}-01-10`)).map((date) => date.toDateString()),
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-04-14`), new Date(`${new Date().getFullYear()}-04-17`)).map((date) => date.toDateString()),
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-07-21`), new Date(`${new Date().getFullYear()}-07-25`)).map((date) => date.toDateString()),
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-07-27`), new Date(`${new Date().getFullYear()}-08-03`)).map((date) => date.toDateString()),
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-08-19`), new Date(`${new Date().getFullYear()}-09-01`)).map((date) => date.toDateString()),
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-11-24`), new Date(`${new Date().getFullYear()}-12-31`)).map((date) => date.toDateString())
		],
		$24: [

			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-01-01`), new Date(`${new Date().getFullYear()}-01-18`)).map((date) => date.toDateString()),
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-07-24`), new Date(`${new Date().getFullYear()}-08-08`)).map((date) => date.toDateString()),
			...this.getDatesInRange(new Date(`${new Date().getFullYear()}-11-30`), new Date(`${new Date().getFullYear()}-12-31`)).map((date) => date.toDateString())
		]
	};

	static getDatesInRange(startDate: Date, endDate: Date): Date[] {
		const dateArray: Date[] = [];
		let currentDate = new Date(startDate);
		while (currentDate <= endDate) {
			dateArray.push(new Date(currentDate));
			currentDate.setDate(currentDate.getDate() + 1);
		}
		return dateArray;
	}

	static getMonthEvents(month: number, year: number) {
		const events = this.monthsData[`$${month.toString().length === 1 ? `0${month}` : month}${year.toString().slice(2)}`];
		return events;
	}

	static getYearVacations(year: number) {
		const x = this.yearVacations[`$${year.toString().slice(2)}`];
		return x && x.length > 0 ? x : [];
	}

	static getYearEvents(year: number) {
		const keys = Object.keys(this.monthsData).filter(key => key.includes(year.toString().slice(-2)));
		const events = keys.reduce((acc, key) => {
			acc[key] = this.monthsData[key];
			return acc;
		}, {});
		return events;
	}
}